
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/author/[authorSlug]",
      function () {
        return require("private-next-pages/news/author/[authorSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news/author/[authorSlug]"])
      });
    }
  